const videoModalSelector = '.js-video-modal';
const videoModalIframeSelector = '.videoModalIframe, .video-modal-iframe';
const videoTriggerSelector = 'a.video[data-bs-toggle="modal"], button.video[data-bs-toggle="modal"]';
const removeWwwPrefix = (hostname) => hostname.replace(/^www\./, '');
const getFirstPathSegment = (pathname) => pathname.split('/').find(Boolean) || '';
const getLastPathSegment = (pathname) => pathname.split('/').findLast(Boolean) || '';

const getYouTubeEmbedUrl = (url) => {
    const host = removeWwwPrefix(url.hostname);

    if (host === 'youtu.be') {
        const videoId = getFirstPathSegment(url.pathname);
        return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    }

    if (host === 'youtube.com' || host === 'm.youtube.com') {
        const videoId = url.searchParams.get('v');
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}`;
        }

        const pathParts = url.pathname.split('/').filter(Boolean);
        const isEmbedOrShortsUrl = pathParts[0] === 'embed' || pathParts[0] === 'shorts';

        if (isEmbedOrShortsUrl) {
            return pathParts[1] ? `https://www.youtube.com/embed/${pathParts[1]}` : '';
        }
    }

    return '';
};

const getVimeoEmbedUrl = (url) => {
    const videoId = getLastPathSegment(url.pathname);
    return videoId ? `https://player.vimeo.com/video/${videoId}` : '';
};

const getEmbedUrl = (rawUrl) => {
    if (!rawUrl) {
        return '';
    }

    try {
        const url = new URL(rawUrl, window.location.href);
        const host = removeWwwPrefix(url.hostname);

        if (host === 'youtu.be' || host === 'youtube.com' || host === 'm.youtube.com') {
            return getYouTubeEmbedUrl(url) || rawUrl;
        }

        if (host === 'vimeo.com' || host === 'player.vimeo.com') {
            return getVimeoEmbedUrl(url) || rawUrl;
        }
    } catch {
        return rawUrl;
    }

    return rawUrl;
};

const withAutoplay = (url) => {
    if (!url) {
        return '';
    }

    if (url.includes('autoplay=1')) {
        return url;
    }

    return url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;
};

export const initVideoPopup = (Modal) => {
    document.querySelectorAll(videoTriggerSelector).forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            const targetSelector = trigger.dataset.bsTarget;
            const modalEl = targetSelector ? document.querySelector(targetSelector) : null;

            if (!modalEl) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            Modal.getOrCreateInstance(modalEl).show(trigger);
        });
    });

    document.querySelectorAll(videoModalSelector).forEach((modalEl) => {
        Modal.getOrCreateInstance(modalEl);

        const iframe = modalEl.querySelector(videoModalIframeSelector);
        if (iframe) {
            iframe.style.opacity = '0';
            iframe.style.transition = 'opacity 80ms ease';

            iframe.addEventListener('load', () => {
                iframe.style.opacity = '1';
            });
        }

        modalEl.addEventListener('shown.bs.modal', (event) => {
            const trigger = event.relatedTarget;
            if (!trigger) {
                return;
            }

            const rawUrl =
                trigger.dataset.videoSrc ||
                trigger.dataset.mfpSrc ||
                trigger.getAttribute('href');

            const container = trigger.parentElement;
            const videoTitle = container?.querySelector('.video-title')?.textContent?.trim() || '';

            if (!rawUrl) {
                return;
            }

            if (!iframe) {
                return;
            }

            const embedUrl = getEmbedUrl(rawUrl);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'video_popup_opened',
                video_url: embedUrl,
                video_title: videoTitle
            });

            iframe.style.opacity = '0';
            iframe.setAttribute('src', withAutoplay(embedUrl));
        });

        modalEl.addEventListener('hidden.bs.modal', () => {
            if (iframe) {
                iframe.style.opacity = '0';
                iframe.setAttribute('src', '');
            }
        });
    });
};
